<template>
  <b-container>
    <b-row>
      <b-col
        class="px-4 col-sm-12 col-md-8 col-lg-12 col-xl-12 offset-md-2 offset-lg-0 offset-xl-0 col-12"
        :class="notifications.length > 0 ? 'mt-3' : ''"
      >
        <NotificationBar v-for="notification in notifications" :key="notification.id" :notification="notification" />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapState } from 'vuex';
import NotificationBar from '@/components/NotificationBar';

export default {
  name: 'NotificationContainer',
  components: {
    NotificationBar,
  },
  computed: mapState('notification', ['notifications']),
};
</script>

<style lang="scss" scoped></style>
